import { ref } from '@nuxtjs/composition-api';
const isMembranaLoad = ref(false);
export const initializeMembrana = (adTags, adConfig, isMobile) => {
  const excludeCategories = ['Goygoy', 'Spor', 'Gaming', 'Teknoloji', 'Eğitim', 'Genel Kültür'];
  const membranaCategory = adConfig.value.fetchData?.value.breadcrumb?.reverse()?.some((cat) => {
    return excludeCategories.includes(cat.name);
  });

  if (!membranaCategory && isMobile.value) {
    if (!isMembranaLoad.value) {
      adTags.script.push(
        {
          hid: 'membrana',
          src: 'https://cdn.membrana.media/ond/ym.js',
          class: 'membrana',
          defer: true,
          callback: () => {
            isMembranaLoad.value = true;
          },
        },
        {
          hid: 'membranaAnalyticsInit',
          innerHTML: `
            window.yieldMasterCmd = window.yieldMasterCmd || [];
            window.yieldMasterCmd.push(function() {
                window.yieldMaster.init({
                    pageVersionAutodetect: true
                });
            });
          `,
        }
      );
      adTags.__dangerouslyDisableSanitizersByTagID.teadsAnalyticsInit = ['innerHTML'];
    }
  }
};
